import BackendService from './backend_service.js'
import BackendRoutes from './backend_routes.js.erb'
export {BackendService,BackendRoutes}